var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mdb-container',{staticClass:"mt-5 p-3 pt-5"},[_c('mdb-row',{staticClass:"mb-3"},[_c('mdb-col',{staticClass:"justify-content-center text-center"},[_c('mdbCard',[_c('mdbCardBody',[_c('h1',[_vm._v("Page Not Found")])])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }